// components/ServiceCarousel.js
import React from 'react';

const ServiceCarousel = () => {
    const services = [
        {
            id: 1,
            title: "Garde d'enfants",
            description: "Vous recherchez une nounou pour quelques heures par jour, le soir ou de façon permanente ? Vous trouverez ici des nounous ayant de l'expérience, des références et des postes vacants - pour aider les tout-petits, les enfants plus âgés et les urgences.",
            link: "/baby-sitting",
            image: "assets/images/banner/banner3.jpg"
        },
        {
            id: 2,
            title: "Aide à domicile",
            description: "Vous avez besoin de quelqu'un pour s'occuper d'une personne âgée à domicile, l'aider dans ses activités quotidiennes ou simplement lui tenir compagnie ? Consultez les prestataires de soins disponibles dans votre région et choisissez quelqu'un en qui vous pouvez avoir confiance.",
            link: "/aide-domicile",
            image: "assets/images/banner/banner4.jpg"
        },
        {
            id: 3,
            title: "Ménage",
            description: "Vous en avez assez de vous occuper de tout vous-même ? Consultez les profils des personnes qui proposent des services de nettoyage d'appartements, de maisons et de bureaux. Qu'il s'agisse d'un nettoyage ponctuel ou d'une assistance permanente, adaptez le service à votre routine quotidienne.",
            link: "/menage",
            image: "assets/images/banner/banner1.jpg"
        },
        {
            id: 4,
            title: "Soutien scolaire",
            description: "Votre enfant ne comprend pas les mathématiques ? Ou peut-être voulez-vous vous souvenir de l'anglais ? Vous trouverez ici des professeurs particuliers dans un grand nombre de matières - pour des cours en ligne ou en magasin. Du primaire à l'université, avec des avis et des tarifs spécifiques.",
            link: "/soutien-scolaire",
            image: "assets/images/banner/banner2.jpg"
        }
    ];

    return (
        <>
            <section className="breadcrumnd-section bg1 py-xxl-25 py-20">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-7">
                            <div className="breadcrumnd-content">
                                <div className="section-title text-center">
                                    <div className="news-media d-flex align-items-center justify-content-center gap-1 mb-4 aos-init aos-animate" data-aos="zoom-in-right" data-aos-duration="1500">
                                            <span className="fw-600 text-uppercase fs18 p1-clr text-uppercase">
                                                Services
                                            </span>
                                    </div>
                                    <h1 className="n900-clr mb-xxl-6 mb-xl-5 mb-4 aos-init aos-animate" data-aos="zoom-in-right" data-aos-duration="1600">
                                        Services disponibles
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="blog-section n0-bg pb-120">
                <div className="container">
                    <div className="row g-xxl-6 g-4">
                        {services.map((service) => (
                            <div key={service.id} className="col-lg-6 col-md-6">
                                <div className="news-item n900-border bg1 p-xxl-8 p-xl-6 p-lg-4 p-3">
                                    <div className="news-thumb overflow-hidden w-100">
                                        <img src={service.image} alt={service.title}
                                             className="overflow-hidden w-100"/>
                                    </div>
                                    <div className="content pt-xxl-9 pt-8">
                                        <h4 className="n900-clr mb-4">
                                            <a href={service.link}>
                                                {service.title}
                                            </a>
                                        </h4>
                                        <p className="mb-4">
                                            {service.description}
                                        </p>
                                        <a href={service.link}
                                           className="reading-btn d-flex align-items-center gap-2"
                                        >
                                            <span className="text" style={{color: '#1d8d36'}}>
                                                En savoir plus
                                            </span>
                                            <span className="arr">
                                                <i className="ph-bold ph-arrow-right"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServiceCarousel;